module.exports = __webpack_public_path__ + "static/media/ownerShipIcon.dddab005.svg";